import axios from "axios";

export const melliInstance = axios.create({
  baseURL: "https://melli.aeontechhub.com/",
});

export const gangtokInstance = axios.create({
  baseURL: "https://gangtok.aeontechhub.com/",
});

export const siliguriInstance = axios.create({
  baseURL: "https://siliguri.aeontechhub.com/",
});

export const jorethangInstance = axios.create({
  baseURL: "https://jorathang.aeontechhub.com/",
});

export const jalipoolInstance = axios.create({
  baseURL: "https://jalipool.aeontechhub.com/",
});
